import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './LastTransferSubjects.translations.json';
import React from 'react';
import { DashboardPanel } from '../DashboardPanel';
import { Flex } from 'antd';
import { keepPreviousData } from '@tanstack/react-query';
import { useGetLastTransferSubjectsQuery } from './query/useGetLastTransferSubjectsQuery';
import {
  formatDateTimeShort,
  getDayjs,
  MIN_TIMESTAMP,
} from '../../common/utils';
import { colorAccent1 } from '@atlas-frontend/design-tokens';
import * as Icon from 'react-feather';
import { InfoIconUrl } from '../../common/components';

const { addTranslations, t } = i18nNsFactory('last-transfer-subjects');
addTranslations(translations);

export const LastTransferSubjects = () => {
  const { data: lastTransferSubjects, isLoading } =
    useGetLastTransferSubjectsQuery({
      placeholderData: keepPreviousData,
    });

  const dayjsSuccessfulMulty = getDayjs(
    lastTransferSubjects?.successfulMulty || MIN_TIMESTAMP,
  );
  const dayjsErrorMulty = getDayjs(
    lastTransferSubjects?.errorMulty || MIN_TIMESTAMP,
  );
  const dayjsSuccessfulSingle = getDayjs(
    lastTransferSubjects?.successfulSingle || MIN_TIMESTAMP,
  );

  const showErrorMulty = dayjsSuccessfulMulty?.isBefore(dayjsErrorMulty);
  const showSuccessfulSingle = dayjsSuccessfulMulty?.isBefore(
    dayjsSuccessfulSingle,
  );

  return (
    <DashboardPanel
      title={t('title')}
      infoIconUrl={InfoIconUrl.LAST_TRANSFER_SUBJECTS}
      isLoading={isLoading}
      showMaximize={false}
    >
      <Flex gap="small">
        <Flex vertical gap="small">
          <strong>{t('successfulMulty.label')}: </strong>
          {showErrorMulty && <strong>{t('errorMulty.label')}: </strong>}
          {showSuccessfulSingle && (
            <strong>{t('successfulSingle.label')}: </strong>
          )}
        </Flex>
        <Flex vertical gap="small">
          <span>
            {formatDateTimeShort(lastTransferSubjects?.successfulMulty)}
          </span>
          {showErrorMulty && (
            <Flex gap="small">
              <span>
                {formatDateTimeShort(lastTransferSubjects?.errorMulty)}
              </span>
              <Icon.AlertTriangle size={18} color={colorAccent1} />
            </Flex>
          )}
          {showSuccessfulSingle && (
            <span>
              {formatDateTimeShort(lastTransferSubjects?.successfulSingle)}
            </span>
          )}
        </Flex>
      </Flex>
    </DashboardPanel>
  );
};
